module.exports = __webpack_public_path__ + "32d0e0061a3bbb3226a6c4377a5bf2ae.svg";